"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentlyViewedSourceEnum = void 0;
var RecentlyViewedSourceEnum;
(function (RecentlyViewedSourceEnum) {
    RecentlyViewedSourceEnum["Search"] = "S";
    RecentlyViewedSourceEnum["Dashboard"] = "D";
    RecentlyViewedSourceEnum["Tab"] = "T";
})(RecentlyViewedSourceEnum = exports.RecentlyViewedSourceEnum || (exports.RecentlyViewedSourceEnum = {}));
